import { Action, createReducer, on } from '@ngrx/store';

import * as TestMonkeyActions from '../actions/test-monkey.actions';

export interface TestMonkeyState {
  monkeyMood: boolean;
  isRunning: boolean;
  isNew: boolean;
  isDeathVerified: boolean;
  personalId: string;
  branches: any;
  responses: any;
}

export const initialState: TestMonkeyState = {
  monkeyMood: false,
  isRunning: false,
  isNew: false,
  personalId: '',
  isDeathVerified: false,
  branches: {},
  responses: [],
};

const testMonkeyReducer = createReducer(
  initialState,
  on(TestMonkeyActions.testMonkeyToggle, (state, prop) => {
    return {
      ...state,
      monkeyMood: prop.payload,
    };
  }),

  on(TestMonkeyActions.testMonkeyStart, (state, prop) => {
    return {
      ...state,
      isRunning: prop.payload,
    };
  }),
  on(TestMonkeyActions.testMonkeyMoveNew, (state) => {
    return {
      ...state,
      isNew: true,
    };
  }),
  on(TestMonkeyActions.testMonkeyMoveExisting, (state) => {
    return {
      ...state,
      isNew: false,
    };
  }),
  on(TestMonkeyActions.testMonkeyUpdatePersonalId, (state, prop) => {
    return {
      ...state,
      personalId: prop.payload,
    };
  }),
  on(TestMonkeyActions.testMonkeyUpdateDeathVerified, (state, prop) => {
    return {
      ...state,
      isDeathVerified: prop.payload,
    };
  }),
  on(TestMonkeyActions.testMonkeyUpdateResponses, (state, prop) => {
    const index = state.responses.length - 1;

    const temp = [...state.responses[index], ...prop.payload];
    const newArray = [...state.responses];
    newArray[index] = temp;

    return {
      ...state,
      responses: newArray,
    };
  }),
  on(TestMonkeyActions.testMonkeyUpdateScenarios, (state, prop) => {
    return {
      ...state,
      branches: {
        ...state.branches,
        ...prop.payload,
      },
    };
  }),

  on(TestMonkeyActions.testMonkeyPopulateScenario, (state, prop) => {
    return {
      ...state,
      responses: [...state.responses, [prop.payload]],
    };
  }),
);

export function reducer(state: TestMonkeyState | undefined, action: Action) {
  return testMonkeyReducer(state, action);
}
